import "./scrollable.css";
import GraphQLService from "../shared/GraphQLService";
import useSWR from "swr";
import { Table, TableCell, TableHeading } from "@nike/eds";
import { Page, PageHeader } from "@nike/epic-react-ui";

const api = new GraphQLService();

const FlowSearchPanel = () => {
  return <h1>Future searchpanel</h1>;
};

const useSearchApi = () => {
  const fetcher = async () => await api.findWorkFlows();
  return useSWR({ type: "FlowOverviewSearch" }, fetcher, {
    refreshInterval: 15000,
  });
};

const FlowSearchResult = () => {
  const { data } = useSearchApi();
  console.log("FlowSearchResult data", data);
  if (data?.data?.findWorkFlows?.items) {
    const rows = data.data.findWorkFlows.items;
    return (
      <div className="eds-grid eds-grid--m-cols-6 eds-elevation--4">
        <Table className="eds-grid--m-col-6 eds-grid--item-align-start">
          <thead>
            <tr>
              <TableHeading>Container</TableHeading>
              <TableHeading>Bill Of Lading</TableHeading>
              <TableHeading>Status</TableHeading>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <TableCell>{row.container}</TableCell>
                <TableCell>{row.bol}</TableCell>
                <TableCell>{row.status}</TableCell>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
  return <></>;
};

export function FlowOverview({ history }) {
  return (
    <Page
      documentTitle="Analytics - Customs Compliance Hub"
      width="full"
      className="scrollable"
    >
      <PageHeader
        title="Analytics (Future Scope)"
        summary="This section will provide insights into compliance trends and operational efficiency once implemented."
      />
      {/* <FlowSearchPanel /> */}
      {/* <FlowSearchResult /> */}
    </Page>
  );
}
